import { ShieldCheck } from 'lucide-react'
import { ReportPageLayout, type ReportColumn, type SummaryStat } from './ReportPageLayout'
import { generateVerificationSummaryReport } from '@/src/lib/api/admin-reports'
import type { VerificationSummaryRow } from '@/src/types/admin/reports'

const fmtN = (v: unknown) => Number(v ?? 0).toLocaleString('th-TH')
const fmt2 = (v: unknown) =>
  Number(v ?? 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })

const columns: ReportColumn[] = [
  { key: 'bank_code', label: 'ธนาคาร' },
  { key: 'status', label: 'สถานะ' },
  { key: 'count', label: 'จำนวน', format: fmtN },
  { key: 'total_amount', label: 'ยอดรวม (฿)', format: fmt2 },
  {
    key: 'avg_processing_ms',
    label: 'เฉลี่ย (ms)',
    format: (v) => `${Number(v ?? 0).toFixed(0)}`,
  },
]

function extractRows(data: unknown): Record<string, unknown>[] {
  if (Array.isArray(data)) return data as Record<string, unknown>[]
  return []
}

function extractSummary(data: unknown): SummaryStat[] {
  const rows = extractRows(data) as unknown as VerificationSummaryRow[]
  const total = rows.reduce((s, r) => s + Number(r.count ?? 0), 0)
  const totalAmt = rows.reduce((s, r) => s + Number(r.total_amount ?? 0), 0)
  const successful = rows
    .filter(r => r.status === 'success' || r.status === 'verified')
    .reduce((s, r) => s + Number(r.count ?? 0), 0)
  return [
    { label: 'จำนวนการตรวจสอบทั้งหมด', value: fmtN(total) },
    { label: 'สำเร็จ', value: fmtN(successful) },
    { label: 'ยอดเงินรวม', value: `฿${fmt2(totalAmt)}` },
  ]
}

export default function AdminReportVerifications() {
  return (
    <ReportPageLayout
      title="รายงานสรุปการยืนยันสลิป"
      description="Success/fail ตามธนาคาร, จำนวนเงิน, เวลาประมวลผล"
      audience="ผู้บริหาร / เทคนิค"
      icon={ShieldCheck}
      columns={columns}
      fetchFn={generateVerificationSummaryReport}
      extractRows={extractRows}
      extractSummary={extractSummary}
      filenamePrefix="verification_summary"
    />
  )
}
